module.exports = __webpack_public_path__ + "z/professional-desktop.46306085.jpg";